/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommentsLogs/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Comments from './Comments/index'
import Logs from './Logs/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChatBubble from 'DesignSystem/Svgs/Tysiav2ChatBubble/index'
import Tysiav2LogsIcon from 'DesignSystem/Svgs/Tysiav2LogsIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CommentsLogs({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/CommentsLogs",
  ignoreClickOutsideIf
  
}) {
let taskCommentsAggregateAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'comments_aggregate.aggregate.count',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let taskAuditLogsAggregateAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'audit_logs_aggregate.aggregate.count',
})
  return (<React.Fragment
>
<div
  data-testid="CommentsLogs.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CommentsLogs.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Popover
  viewPath={`${viewPath}/Popover`}
 ignoreClickOutsideIf={ignoreClickOutsideIf}
 placement="bottom"
 offsetMainAxis={4}
 offsetCrossAxis={-170}
 width={240}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="CommentsLogs.Horizontal:1"
  data-view-path={viewPath}
 title="View comments"
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2ChatBubble
  viewPath={`${viewPath}/Tysiav2ChatBubble`}
 width={14}
 height={14}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingLeft={dtSpaceXxxs}
 color={dtColorsNeutral600}
 data="task.comments_aggregate.aggregate.count"
 text={taskCommentsAggregateAggregateCountValueData}
/>
</div>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Comments
{...childProps}
  viewPath={`${viewPath}/Comments`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
<div
  data-testid="CommentsLogs.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-1-19zkao': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<Popover
  viewPath={`${viewPath}/Popover`}
 ignoreClickOutsideIf={ignoreClickOutsideIf}
 placement="bottom"
 offsetMainAxis={4}
 offsetCrossAxis={-170}
 width={240}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="CommentsLogs.Horizontal:2"
  data-view-path={viewPath}
 title="View activity log"
 className={`views-block ${styles.Horizontal2}`}
>
<Tysiav2LogsIcon
  viewPath={`${viewPath}/Tysiav2LogsIcon`}
 width={14}
 height={14}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingLeft={dtSpaceXxxs}
 color={dtColorsNeutral600}
 data="task.audit_logs_aggregate.aggregate.count"
 text={taskAuditLogsAggregateAggregateCountValueData}
/>
</div>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Logs
{...childProps}
  viewPath={`${viewPath}/Logs`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
</div>
</div>
</div>
{children}
</React.Fragment>)
}